export default "__VITE_ASSET__CZUaZvd0__"